export enum HandlerId {
  trueChild = 'trueChild',
  falseChild = 'falseChild',
}

export enum PathType {
  True = 'truePath',
  False = 'falsePath',
}
